import './index.css';
import { Editor } from './core/Editor';
import { TopMenu } from './ui/TopMenu';
import { ToolBar } from './ui/ToolBar';
import { OptionsBar } from './ui/OptionsBar';
import { LayersPanel } from './ui/LayersPanel';
import { HistoryPanel } from './ui/HistoryPanel';

document.addEventListener('DOMContentLoaded', () => {
  const topMenuContainer = document.querySelector<HTMLElement>('#top-menu-container')!;
  const toolbarContainer = document.querySelector<HTMLElement>('#toolbar-container')!;
  const optionsbarContainer = document.querySelector<HTMLElement>('#optionsbar-container')!;
  const viewportContainer = document.querySelector<HTMLElement>('#canvas-viewport')!;
  const layersContainer = document.querySelector<HTMLElement>('#layers-panel-container')!;
  const historyContainer = document.querySelector<HTMLElement>('#history-panel-container')!;

  // 1. Initialize master editor
  const editor = new Editor(viewportContainer);

  // 2. Initialize UI components
  const topMenu = new TopMenu(editor, topMenuContainer);
  const toolbar = new ToolBar(editor, toolbarContainer);
  const optionsBar = new OptionsBar(editor, optionsbarContainer);
  const layersPanel = new LayersPanel(editor, layersContainer);
  const historyPanel = new HistoryPanel(editor, historyContainer);

  // Initial options bar
  optionsBar.render(editor.toolManager.activeTool.id);
  layersPanel.render();

  // 3. Connect reactive events
  editor.onLayersChange = () => {
    layersPanel.render();
    updateStatusBar();
  };

  editor.onActiveLayerChange = () => {
    layersPanel.render();
    updateStatusBar();
  };

  editor.onToolChangeCallback = (toolId) => {
    toolbar.setActiveTool(toolId);
    optionsBar.render(toolId);
    updateStatusBar();
  };

  editor.history.subscribe((canUndo, canRedo, steps, activeIndex) => {
    historyPanel.render(steps, activeIndex);
  });

  editor.onZoomChange = (zoom) => {
    const zoomText = document.querySelector('#status-zoom-val');
    if (zoomText) zoomText.textContent = `${Math.round(zoom * 100)}%`;
  };

  // 4. Status Bar Controls
  const updateStatusBar = () => {
    const dimText = document.querySelector('#status-dimensions');
    if (dimText) {
      dimText.textContent = editor.hasDocument
        ? `${editor.width} × ${editor.height} px`
        : 'Blank (Drop photo to start)';
    }

    const layerText = document.querySelector('#status-layer');
    if (layerText) {
      if (!editor.hasDocument) {
        layerText.textContent = 'None';
      } else {
        const active = editor.getActiveLayer();
        layerText.textContent = active ? active.name : 'No Layer';
      }
    }
  };

  document.querySelector('#zoom-in-btn')?.addEventListener('click', () => {
    if (editor.hasDocument) editor.setZoom(editor.zoom * 1.25);
  });

  document.querySelector('#zoom-out-btn')?.addEventListener('click', () => {
    if (editor.hasDocument) editor.setZoom(editor.zoom * 0.8);
  });

  document.querySelector('#zoom-fit-btn')?.addEventListener('click', () => {
    if (editor.hasDocument) editor.centerViewport();
  });

  document.querySelector('#status-cf-badge')?.addEventListener('click', () => {
    editor.openCloudflareModal();
  });

  // Right sidebar tab switching (Layers / Adjustments / History)
  const tabButtons = document.querySelectorAll('.sidebar-tab-btn');
  tabButtons.forEach(btn => {
    btn.addEventListener('click', (e) => {
      tabButtons.forEach(b => b.classList.remove('active'));
      const target = e.currentTarget as HTMLElement;
      target.classList.add('active');
      const tabName = target.dataset.tab;

      const layersCard = document.querySelector('#layers-panel-container') as HTMLElement;
      const historyCard = document.querySelector('#history-panel-container') as HTMLElement;

      if (tabName === 'layers') {
        if (layersCard) layersCard.style.display = 'block';
        if (historyCard) historyCard.style.display = 'none';
      } else if (tabName === 'history') {
        if (layersCard) layersCard.style.display = 'none';
        if (historyCard) historyCard.style.display = 'block';
      }
    });
  });

  // Initial status update - starts clean and blank
  updateStatusBar();
});
